<template>
   <div>
      <div class="print-row">
         <a @click="print()" class="print-tickets" >{{ $t('general.label.print') }}</a>
      </div>
      <div class="header-row ">
         <div class="logo "><img :src="companyDetails.companyLogoUrl"></div>
         <div class="company-info ">
            <h3 v-if="companyDetails.name">{{ companyDetails.name }}</h3>
            <h3 v-if="companyDetails.address">{{ companyDetails.address }}</h3>
            <h3 v-if="companyDetails.state && companyDetails.country">{{ companyDetails.state }}, {{ companyDetails.country }}</h3>
            <h3 v-if="companyDetails.website">{{ companyDetails.website }}</h3>
            <h3 v-if="companyDetails.email">{{ companyDetails.email }}</h3>
         </div>
      </div>

      <div class="orderDetails ">
         <h1>Order Details</h1>
         <table class="ticket-container">
               <tr class="header-row">
                  <th class="activityHeader"><h2>Activity</h2></th>
                  <th class="bookingNoHeader"><h2>Booking #</h2></th>
                  <th class="pickupHeader"><h2>Pickup</h2></th>
                  <th class="priceHeader"><h2>Price</h2></th>
               </tr>

               <!-- Loop over tickets/cart items here -->
               <tr v-for="(item,index) in ticketItems" :key="index" class="activity-row ">
                  <td>
                     <h2>{{ item.tickets[0].activityName }}</h2>
                     <p>{{ formatDate(item.date) }}</p>
                     <span v-for="pricingItem in item.activityPriceBreakdown" :key="`${pricingItem.label}_pax`">
                        <p v-if="pricingItem.type  == 'pax'">
                           <span class="blue-text ">{{ pricingItem.qty }} {{ paxLabel(item, pricingItem) }}</span> x {{ $formatter.currency(pricingItem.unitPrice) }}
                        </p>
                     </span>
                     <!-- Loop over options here -->
                     <span v-for="pricingItem in item.activityPriceBreakdown" :key="`${pricingItem.label}_option`">
                        <p v-if="pricingItem.type == 'option'">
                           <span class="blue-text ">{{ pricingItem.qty + " " + pricingItem.label }}</span> x {{$formatter.currency(pricingItem.unitPrice) }}
                        </p>
                     </span>
                  </td>

                  <td>
                     <h2>{{ bookingId }}</h2>
                  </td>

                  <td>
                     <p v-if="item.tickets[0].pickupLocationTime">{{ item.tickets[0].pickupLocationTime }}</p>
                  </td>

                  <td>
                     <h2>{{ $formatter.currency(totalActivityPrice(item.activityPriceBreakdown)) }}</h2>
                     <img :src="item.tickets[0].barCodeImageUrl" width="150">
                  </td>
               </tr>

               <tr class="footer-row ">
                  <td colspan="2"></td>
                  <td colspan="2">
                     <table class="totals">
                        <tr><td><h3>{{ $t('general.label.subtotal') }}:</h3></td><td><h3>{{ $formatter.currency(cart.subTotal ? cart.subTotal : 0) }}</h3></td></tr>
                        <tr v-if="cart.discount"><td><h3>{{ $t('general.label.discount') }}:</h3></td><td><h3>{{ $formatter.currency(cart.discount) }}</h3></td></tr>
                        <tr v-if="cart.surcharge"><td><h3>{{ cart.surcharge.name }}:</h3></td><td><h3>{{ $formatter.currency(cart.surcharge.amount) }}</h3></td></tr>
                        <tr><td><h3>{{ $t('general.label.gst') }}:</h3></td><td><h3>{{ $formatter.currency(cart.taxes ? cart.taxes : 0) }}</h3></td></tr>
                        <tr v-if="cart.guestFee"><td><h3>{{ $t('general.label.booking-fee') }}:</h3></td><td><h3>{{ $formatter.currency(cart.guestFee) }}</h3></td></tr>
                        <tr><td><h2>{{ $t('general.label.total') }}:</h2></td><td><h2>{{ $formatter.currency(cart.total ? cart.total : 0) }}</h2></td></tr>
                     </table>
                  </td>
               </tr>
         </table>
      </div>

      <div class="bottom-details">
         <div class="guest-details" v-if="cart.cartGuests[0]">
            <h1>{{ $t('form.label.guest-details') }}</h1>
            <h2>{{ cart.cartGuests[0].firstName + " " +  cart.cartGuests[0].lastName}}</h2>
            <h3>{{ $t('form.label.guest.phone') + ": " + cart.cartGuests[0].phone }}</h3>
            <h3>{{ $t('form.label.guest.email') + ": " + cart.cartGuests[0].email }}</h3>
         </div>

         <div class="payment-details" v-if="cart.cartTransactions[0]">
            <h1>{{ $t('form.label.payment') }}</h1>
            <h3>{{ $t('form.label.payment-type') }}: {{ paymentDetails(cart.cartTransactions[0]) }}</h3>
            <h3>{{ $t('form.label.date') }}: {{ formatDate(cart.cartTransactions[0].transactionDate) }}</h3>
            <h3>{{ $t('general.label.amount') }}: {{ $formatter.currency(cart.cartTransactions[0].amount) }}</h3>
         </div>
      </div>

      <hr>


   </div>
</template>

<script>
import Cart from '@/models/Cart';
import moment from 'moment';
import PortalSettings from '@/models/PortalSettings';
import CartItem from '@/models/CartItem';

export default {
   props: ['bookingId', 'be'],

   data(){
      return {
         cart: new Cart(),
         company: "Zaui Software"
      }
   },

   created() {
   Cart.loadBooking(this.bookingId, this.be).then(data => {
         // This needs to use some sort of authorization
         this.cart = Cart.query().with('items').where('bookingId', this.bookingId).first();
      });
   },

   computed: {
      activityItems(){
         if (!this.cart.items){
            return [];
         }
         return this.cart.items.filter((item) => {return item.type =='activity'});
      },
      packageItems(){
         if (!this.cart.items){
            return [];
         }
         return this.cart.items.filter((item) => {return item.type =='package'});
      },
      ticketItems(){
         var ticketItems = [];
         this.activityItems.forEach((item) => {
            item.tickets.forEach((ticket)=> {
               var temp = JSON.parse(JSON.stringify(item));
               temp.tickets = [];
               temp.tickets.push(ticket);
               ticketItems.push(new CartItem(temp));
            });
         });
         this.packageItems.forEach((item) => {
            item.packageActivities.forEach((activity) => {
               activity.tickets.forEach((ticket) => {
                  var temp = JSON.parse(JSON.stringify(item));
                  temp.tickets = [];
                  temp.tickets.push(ticket);
                  ticketItems.push(new CartItem(temp));
               });
            });
         });
         return ticketItems;
      },
      companyDetails(){
         return PortalSettings.get('companyDetails');
      }
   },

   methods: {
      formatDate(date){
         return moment(date).format("dddd, MMM D, YYYY");
      },

      totalActivityPrice(breakdown){
         return breakdown.reduce((acc, priceItem) => {
            return acc + priceItem.subTotal;
         }, 0);
      },

      print(){
         window.print();
      },

      paymentDetails(transaction) {
        let payment = transaction.methodName;

        // Only show gateway for credit card transactions (2000 for charge, or 2009 for refund)
        if(transaction.methodId == 2000 || transaction.methodId == 2009) {
          payment += (transaction.gatewayName ? " (" + transaction.gatewayName + ")" : "");
        }

        return payment;
      },

      paxLabel(item, priceItem) {
        let paxPrefix = "";

        if(item.type == "activity") {
          paxPrefix = `activity${item.itemId}.`;
        } else if(item.type == "package") {
          paxPrefix = `package${item.itemId}.`;
        }

        let key = `${paxPrefix}guest-picker.${priceItem.label}`;
        let label = this.$tc(key, priceItem.qty);

        if (key === label) {
          // we didn't find a label so fall back to no prefix
          label = this.$tc(`guest-picker.${priceItem.label}`, priceItem.qty);
        }

        return label;
      }
   },
};
</script>


<style lang="scss" scoped>
h1, h2, h3 {
   color: $colorDarkGray;
}

h2 {
   font-size: 20px;
}

h3 {
   font-weight: 300;
   margin: 0 0 4px 0;
}

.logo {
   display: inline-block;
   max-width: 250px;
   max-height: 250px;
   min-width: 150px;
   min-height: 150px;
}

.ticket-container {
   border: 1px solid $colorGray;
   border-collapse: collapse;
   width: 100%;

   > .header-row {
      background-color: $colorBgGray;
      > :first-child {
         text-align: left;
         width: 40%;
      }

      > :not(:first-child) {
         text-align: center;
         width: 20%;
      }
   }

   > .activity-row {
      >td:first-child{
         > p {
            padding-bottom: 5px;
         }
      }

      > td:not(:first-child){
         text-align: center;
      }
      border-bottom: 1px solid $colorGray;
   }

   > .footer-row {
      background-color: $colorBgGray;
      width: 100%;
   }

   > tr {
      border-top: 1px solid $colorGray;
      > td {
         border: none;
         padding: 15px;
      }
   }
}

.bottom-details {
   padding-bottom: 30px;
   padding-top: 20px;
   > * {
      vertical-align: top;
      width: 50%;
      display: inline-block;
      > h1 {
         margin: 25px 0 15px 0;
      }
   }
}

p {
   font-size: 16px;
   color: $colorDarkGray;
}

hr {
   color: $colorPaleGray;
}

th {
   border: none;
   padding: 10px;
}

.blue-text {
   color: $colorBlue;
}

.print-tickets {
   font-size: 22px;
   &::before {
      @include font-awesome-pseudo($fa-var-print, light);
      margin-right: 5px;
   }
   @media print {
      display: none;
   }
}

.print-row {
   text-align: right;
   padding-bottom: 25px;
}

.totals {
   width: 100%;
   text-align: right;
   > tr {
      > td {
         > h3 {
            margin: 0;
         }
      }
   }
}

.company-info {
   display: inline-block;
   position: absolute;
   right: 0;
   top: 0;
}

.header-row {
   position: relative;
}
</style>

<style>
@media print {
   header, footer {
      display: none;
   }
}
</style>